import { countBy, keys, uniq } from 'lodash';
import { browserName } from 'react-device-detect';
import { v4 as uuidv4 } from 'uuid';
import { pluralize } from '../../../utils/stringUtils';

const TAB_UUID_SEPARATOR = '::';
const MOBILE_APP_DEVICE_TEXT = 'Mobile Device';

export const generateTabUuid = (): string =>
  `${browserName}${TAB_UUID_SEPARATOR}${uuidv4()}`;

export const isValidTabUUID = (uuid: string): boolean => {
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(uuid);
};

const isBrowserTab = (deviceName: string): boolean =>
  deviceName.includes(TAB_UUID_SEPARATOR) &&
  isValidTabUUID(deviceName.split(TAB_UUID_SEPARATOR)[1]);

const getBrowserTabInfo = (deviceName: string): string => {
  const [browserInfo] = deviceName.split(TAB_UUID_SEPARATOR);
  return browserInfo;
};

const getMobileDevicesInfo = (allDevices: string[]): string => {
  const mobileDevices = countBy(
    allDevices,
    (deviceName) => deviceName === MOBILE_APP_DEVICE_TEXT
  );
  const mobileDevicesCount = mobileDevices.true || 0;
  return mobileDevicesCount
    ? `${
        mobileDevicesCount > 1 ? `${mobileDevicesCount} ` : ''
      }Mobile ${pluralize('Device', mobileDevicesCount)}`
    : '';
};

const getBrowserDevicesInfo = (allDevices: string[]): string => {
  const browserDevices = allDevices.filter(
    (deviceName) => deviceName !== MOBILE_APP_DEVICE_TEXT
  );
  return uniq(browserDevices).join(', ');
};

export const getTabDevicesName = (devices: {
  [key: string]: number;
}): string => {
  const allDevices = keys(devices).map((deviceName) =>
    isBrowserTab(deviceName)
      ? getBrowserTabInfo(deviceName)
      : MOBILE_APP_DEVICE_TEXT
  );
  const browserDevicesInfo = getBrowserDevicesInfo(allDevices);
  const mobileDevicesInfo = getMobileDevicesInfo(allDevices);

  return `${browserDevicesInfo}${
    browserDevicesInfo && mobileDevicesInfo ? ', ' : ''
  }${mobileDevicesInfo}`;
};
